

<body class="mat-app-background">
<div class="container-fluid m-0 p-0" >
    <div class="row p-0 markets-top-row" #rowContainer>
        <div class="panel-chart analisis-panel">
            <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar">
                <mat-card-content class="">
                    <app-grafica-analisis [compania]="selectedIso" [metaapi]="selectedMetaapi" [idnectum]="selectedIdNectum">
                        <div slot="toolbar-start" class="toolbar-selectors">
                            <div class="select-mercado">
                                <app-mercado-select [mercados]="mercado"
                                    [(ngModel)]="selectedValue"
                                    placeholder="Mercado"
                                    (change)="buscarCompania()">
                                </app-mercado-select>
                            </div>
                            <mat-form-field *ngIf="options" appearance="outline" subscriptSizing="dynamic" floatLabel="always" class="search-compania">
                                <mat-label>Compañia</mat-label>
                                <input type="text" placeholder="Seleccione" aria-label="Number" matInput
                                    [formControl]="myControl" [matAutocomplete]="auto">
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                    (optionSelected)="selected($event)" color="primary">
                                    <cdk-virtual-scroll-viewport itemSize="30" style="height: 223px; width: 100%;">
                                        <mat-option *cdkVirtualFor="let option of filteredOptions | async" [value]="option.iso"


                                        [class.mat-selected]="true"
                                        [class.first-option]="true">
                                            <strong>Iso</strong>{{ option.iso }} - <strong>Descripcion:</strong> {{ option.descripcion}} - <strong>Mercado:</strong>{{option.mercado}} - <strong>Tipo:</strong>{{option.tipo}} - <strong>Volumen:</strong>{{option.volumen}} - <strong>Cotizacion:</strong>{{option.precioteorico}}
                                        </mat-option>
                                    </cdk-virtual-scroll-viewport>
                                </mat-autocomplete>
                            </mat-form-field>
                            <div class="separator"></div>
                        </div>
                        <span slot="toolbar-row2-start" *ngIf="companiaselected" class="compania-nombre">
                            <strong>{{companiaselected.descripcion}}</strong>&nbsp;({{companiaselected.iso}})
                        </span>
                        <span slot="toolbar-after-zoom" *ngIf="selectedValue != null" class="fuente-tag"
                            [title]="mercadoSeleccionadoEsMetaapi ? 'Datos del mercado desde MetaTrader' : 'Datos del mercado desde Nectum API'">
                            {{ mercadoSeleccionadoEsMetaapi ? ('MetaTrader' + (metaapiCuenta ? ' - ' + metaapiCuenta : '')) : 'Nectum API' }}
                        </span>
                    </app-grafica-analisis>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="panel-data">
            <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar watchlist-card">
                <mat-card-content class="">
                    <h6 class="section-title">Watchlist</h6>
                    <div class="watchlist-search">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
                            <mat-label>Añadir símbolo</mat-label>
                            <input matInput [formControl]="watchlistControl" [matAutocomplete]="watchlistAuto"
                                [disabled]="!options" placeholder="Busca en el mercado seleccionado">
                            <mat-autocomplete #watchlistAuto="matAutocomplete" (optionSelected)="addToWatchlist($event.option.value)">
                                <mat-option *ngFor="let option of watchlistFilteredOptions | async" [value]="option.iso">
                                    {{option.iso}} — {{option.descripcion}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="watchlist-list" *ngIf="watchlist.length; else watchlistEmpty">
                        <div class="watchlist-columns">
                            <span></span>
                            <span>Symbol</span>
                            <span>Last</span>
                            <span>Chg</span>
                            <span>Chg%</span>
                            <span></span>
                        </div>
                        <ng-container *ngFor="let grupo of watchlistGroups">
                            <div class="watchlist-group-header" (click)="toggleGroup(grupo.group)">
                                <mat-icon>{{ collapsedGroups.has(grupo.group) ? 'chevron_right' : 'expand_more' }}</mat-icon>
                                <span>{{grupo.group}}</span>
                            </div>
                            <div class="watchlist-row" *ngFor="let item of grupo.items"
                                [hidden]="collapsedGroups.has(grupo.group)"
                                [class.active]="item.simbolo === selectedIso"
                                (click)="selectFromWatchlist(item.simbolo)">
                                <span class="watchlist-avatar" [ngClass]="avatarColor(item.simbolo)">{{item.simbolo.charAt(0)}}</span>
                                <span class="watchlist-iso">{{item.simbolo}}</span>
                                <span class="watchlist-price">{{watchlistQuotes[item.simbolo]?.price ?? '-'}}</span>
                                <span class="watchlist-chg"
                                    [class.numero-positivo]="watchlistQuotes[item.simbolo]?.change > 0"
                                    [class.numero-negativo]="watchlistQuotes[item.simbolo]?.change < 0">{{watchlistQuotes[item.simbolo]?.change ?? '-'}}</span>
                                <span class="watchlist-chg-pct"
                                    [class.numero-positivo]="watchlistQuotes[item.simbolo]?.changesPercentage > 0"
                                    [class.numero-negativo]="watchlistQuotes[item.simbolo]?.changesPercentage < 0">{{watchlistQuotes[item.simbolo]?.changesPercentage != null ? (watchlistQuotes[item.simbolo]?.changesPercentage | number:'1.2-2') + '%' : '-'}}</span>
                                <button mat-icon-button (click)="removeFromWatchlist(item.simbolo, $event)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <ng-template #watchlistEmpty>
                        <p class="watchlist-hint">
                            {{ options ? 'Añade símbolos con el buscador de arriba.' : 'Selecciona primero un mercado en el gráfico.' }}
                        </p>
                    </ng-template>
                </mat-card-content>
            </mat-card>
            <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar" *ngIf="selectedIso">
                <mat-card-content class="">
<!--
                    <h6 class="section-title">Market Data</h6>
                    <div class="metric-row">
                        <span class="metric-label">Último cierre</span>
                        <span class="metric-value">{{quoteshort[0].price}}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">Volumen</span>
                        <span class="metric-value">{{quoteshort[0].volume}}</span>
                    </div>

                    <h6 class="section-title">Efficiency TTM</h6>
                    <div class="metric-row">
                        <span class="metric-label">GrossProfitMargin</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].grossProfitMarginTTM != null ? (ratiosttm[0].grossProfitMarginTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">NetProfitMargin</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].netProfitMarginTTM != null ? (ratiosttm[0].netProfitMarginTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">OperatingProfitMargin</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].operatingProfitMarginTTM != null ? (ratiosttm[0].operatingProfitMarginTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">ReturnOnAssets</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].returnOnAssetsTTM != null ? (ratiosttm[0].returnOnAssetsTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">ReturnOnEquity</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].returnOnEquityTTM != null ? (ratiosttm[0].returnOnEquityTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">ReturnOnCapitalEmployed</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].returnOnCapitalEmployedTTM != null ? (ratiosttm[0].returnOnCapitalEmployedTTM | number:'1.2-2') : '-' }}</span>
                    </div>

                    <h6 class="section-title">Capital Structure TTM</h6>
                    <div class="metric-row">
                        <span class="metric-label">MarketCap</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].marketCapTTM != null ? formatLargeNumber(keymetricsttm[0].marketCapTTM) : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">EnterpriseValue</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].enterpriseValueTTM != null ? formatLargeNumber(keymetricsttm[0].enterpriseValueTTM) : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">PeRatio</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].peRatioTTM != null ? (keymetricsttm[0].peRatioTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">ShareholdersEquityPerShare</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].shareholdersEquityPerShareTTM != null ? (keymetricsttm[0].shareholdersEquityPerShareTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">CashPerShare</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].cashPerShareTTM != null ? (keymetricsttm[0].cashPerShareTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">NetDebtToEBITDA</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].netDebtToEBITDATTM != null ? (keymetricsttm[0].netDebtToEBITDATTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">DebtToEquity</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].debtToEquityTTM != null ? (keymetricsttm[0].debtToEquityTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">DebtToMarketCap</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].debtToMarketCapTTM != null ? (keymetricsttm[0].debtToMarketCapTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">CurrentRatio</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].currentRatioTTM != null ? (keymetricsttm[0].currentRatioTTM | number:'1.2-2') : '-' }}</span>
                    </div>

                    <h6 class="section-title">Valuation TTM</h6>
                    <div class="metric-row">
                        <span class="metric-label">EvToOperatingCashFlow</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].evToOperatingCashFlowTTM != null ? (keymetricsttm[0].evToOperatingCashFlowTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">EnterpriseValueOverEBITDA</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].enterpriseValueOverEBITDATTM != null ? (keymetricsttm[0].enterpriseValueOverEBITDATTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">EbitPerRevenue</span>
                        <span class="metric-value">{{ ratiosttm && ratiosttm.length > 0 && ratiosttm[0].ebitPerRevenueTTM != null ? (ratiosttm[0].ebitPerRevenueTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">EvToFreeCashFlow</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].evToFreeCashFlowTTM != null ? (keymetricsttm[0].evToFreeCashFlowTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">EvToSales</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].evToSalesTTM != null ? (keymetricsttm[0].evToSalesTTM | number:'1.2-2') : '-' }}</span>
                    </div>
                    <div class="metric-row">
                        <span class="metric-label">EvToOperatingCashFlow</span>
                        <span class="metric-value">{{ keymetricsttm && keymetricsttm.length > 0 && keymetricsttm[0].evToOperatingCashFlowTTM != null ? (keymetricsttm[0].evToOperatingCashFlowTTM | number:'1.2-2') : '-' }}</span>
                    </div-->

                    <!-- FAVORITOS -->
                    <h6 class="section-title">Favoritos</h6>
                    <div class="favoritos-links">
                        <a href="https://tradingeconomics.com/" target="_blank" rel="noopener noreferrer">Trading Economics</a>
                        <a href="https://site.financialmodelingprep.com/" target="_blank" rel="noopener noreferrer">Financial Modeling Prep</a>
                        <a href="https://etfdb.com/" target="_blank" rel="noopener noreferrer">ETF Database</a>
                        <a href="https://www.etfreplay.com/screener.aspx" target="_blank" rel="noopener noreferrer">ETF Replay</a>
                        <a href="https://www.justetf.com/es/search.html?search=ETFS" target="_blank" rel="noopener noreferrer">JUST ETF</a>
                        <a href="https://www.financecharts.com/" target="_blank" rel="noopener noreferrer">Finance Charts</a>
                        <a href="https://www.tikr.com/x" target="_blank" rel="noopener noreferrer">TIKR</a>
                        <a href="https://stockrow.com/" target="_blank" rel="noopener noreferrer">Stockrow</a>
                        <a href="https://www.investopedia.com/" target="_blank" rel="noopener noreferrer">Investopedia</a>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <!-- Las pestañas son datos de FMP (v3): no aplican a activos MetaAPI. -->
    <div class="row" style="margin-top: 4px;" *ngIf="selectedIso && !mercadoPendiente && !selectedMetaapi">
        <div class="col-12">
            <mat-card class="mb-2 enrolled-created-box ccorbit-card no-scrollbar">
                <mat-card-content class="">
                    <mat-tab-group (selectedTabChange)="onTabChange($event)">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Descripcion General
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Descripcion General', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-descripcion-general [compania]="selectedIso"></app-descripcion-general>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Noticias
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Noticias', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-noticias [compania]="selectedIso"></app-noticias>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Estados Financieros
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Estados Financieros', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-estados-financieros [compania]="selectedIso"></app-estados-financieros>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Datos Historicos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Datos Historicos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-datos-historicos [compania]="selectedIso" [selectedTab]="selectedTab"
                                [descripcion]="companiaselected">
                            </app-datos-historicos>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Presentaciones
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('Presentaciones', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-presentaciones [compania]="selectedIso"></app-presentaciones>
                        </mat-tab>
                    </mat-tab-group>

                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
</body>
